export const RegistrationType = {
  Participant: "Participant",
  Admin: "Admin",
};
